export default {
      id: "om-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#om",
      toString: function () {
        return this.url;
      }
    }